export default __webpack_public_path__ + "static/media/dan-intro.291c240a.png";